/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs */

const en__field_enum_icsrm_alleinstellungsmerkmal_finden33 = /** @type {(inputs: _Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`find you unique selling point`)
};

const de__field_enum_icsrm_alleinstellungsmerkmal_finden33 = /** @type {(inputs: _Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleinstellungsmerkmal/ USP herausarbeiten`)
};

/**
* | output |
* | --- |
* | "find you unique selling point" |
*
* @param {_Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_alleinstellungsmerkmal_finden33 = /** @type {((inputs?: _Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Alleinstellungsmerkmal_Finden33Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_alleinstellungsmerkmal_finden33(inputs)
	return de__field_enum_icsrm_alleinstellungsmerkmal_finden33(inputs)
});
export { _field_enum_icsrm_alleinstellungsmerkmal_finden33 as "_field_enum_ICSRM_ALLEINSTELLUNGSMERKMAL_FINDEN" }